import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

/**
 * Emergent Google Auth callback handler.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [status, setStatus] = useState("processing"); // processing | done | error
  const [err, setErr] = useState("");

  useEffect(() => {
    let mounted = true;
    const run = async () => {
      try {
        const hash = window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
          navigate("/connexion", { replace: true });
          return;
        }
        const sessionId = decodeURIComponent(match[1]);
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        if (!mounted) return;
        setUser(data);
        setStatus("done");
        // Clean URL and redirect
        window.history.replaceState(null, "", "/dashboard");
        navigate(data?.role === "admin" ? "/admin" : "/dashboard", { replace: true });
      } catch (e) {
        setErr(e?.response?.data?.detail || "Auth failed");
        setStatus("error");
      }
    };
    run();
    return () => { mounted = false; };
  }, [navigate, setUser]);

  return (
    <div className="min-h-[78vh] flex items-center justify-center" data-testid="page-auth-callback">
      <div className="text-center">
        {status === "processing" && <p className="text-[var(--gai-grey-700)]">Authentification…</p>}
        {status === "error" && (
          <div>
            <p className="text-red-400 mb-4">Échec : {String(err)}</p>
            <button onClick={() => navigate("/connexion")} className="gai-btn-outline">Retour connexion</button>
          </div>
        )}
      </div>
    </div>
  );
}
